var map = {
	"./chat-inbound-new.png": "522d",
	"./chat-inbound-new.svg": "459c",
	"./chat-inbound.svg": "16c3",
	"./confeti.svg": "e8de",
	"./facebook-oficitial16x16.svg": "98ff",
	"./gupshup-logo-24x24.png": "9d3f",
	"./gupshup-logo-44x44.png": "1c43",
	"./icon-facebook.png": "2057",
	"./instagram.svg": "970a",
	"./messenger.svg": "8a9d",
	"./sandbox-1.png": "af12",
	"./sandbox-2.png": "8eda",
	"./securitec-full-logo.png": "b935",
	"./securitec-logo-24x24.png": "923c",
	"./securitec-logo-44x44.png": "6678",
	"./securitec-logo-52x52.png": "ea57",
	"./sms-new.svg": "4232",
	"./sms.svg": "a373",
	"./telegram.svg": "efc2",
	"./twilio-full-logo.png": "c560",
	"./twilio-logo-24x24.png": "b893",
	"./twilio-logo-44x44.png": "9fea",
	"./twilio-logo-52x52.png": "109d",
	"./whatsapp.svg": "5e58",
	"./whatsapppng.png": "66da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3a8";